import { Component } from '@angular/core';
import { Globals } from 'src/app/globals/globals'; 
import { ModalController, PopoverController, NavController } from '@ionic/angular';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { SubscriptionCancelReasonPage } from 'src/app/subscription/subscription-cancel-reason/subscription-cancel-reason.page';
import { SubscriptionPlansPage } from 'src/app/subscription/subscription-plans/subscription-plans.page';
import { AnalyticsService } from 'src/app/analytics/analytics.service';
import { LanguageService } from 'src/app/language/language.service';

@Component({
  selector: 'app-user-profile-subscription-tab',
  templateUrl: './user-profile-subscription-tab.component.html',
  styleUrls: ['./user-profile-subscription-tab.component.scss'],
})
export class UserProfileSubscriptionTabComponent {

  constructor(
    public app: Globals,
    private subscriptionService: SubscriptionService,
    private modalController: ModalController,
    private popoverController: PopoverController,
    private navCtrl: NavController,
    private analyticsService: AnalyticsService,
    public lang: LanguageService
  ) {}

  /* Assinar agora */
  async onSubscribeNow() {
    this.analyticsService.logEvent("user_profile_subscription_tab_subscribe_now_click");
    this.modalController.dismiss();
    this.navCtrl.navigateForward('/subscription-plans');
  }

  /* Trocar forma de pagamento */
  onChangePaymentMethod() {
    this.analyticsService.logEvent("user_profile_subscription_tab_change_payment_method_click");
    this.popoverController.dismiss();
    this.subscriptionService.manageSubscriptions();
  }

  /* Cancelar assinatura */
  async cancelSubscription() {
    this.analyticsService.logEvent("user_profile_subscription_tab_cancel_subscription_click");
    const modal = await this.modalController.create({
      component: SubscriptionCancelReasonPage,
      backdropDismiss: false
    });

    await modal.present();
  }

  formatExpiryDate(timestamp: number): string {
    if (!timestamp) return '-';

    return new Date(timestamp).toLocaleDateString(this.app.lang, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  getSubscriptionOrigin(origin: string): string {
    const origins = this.lang.words.userProfile.tabs.subscription.origins;

    switch (origin) {
      case 'play-store':
        return origins.google;
      case 'app-store':
        return origins.apple;
      case 'stripe':
        return origins.stripe;
      case 'manual':
        return origins.manual;
      default:
        return origins.unknown || '-';
    }
  }

  getSubscriptionPlan(planId: string): string {
    const plans = this.lang.words.userProfile.tabs.subscription.plans;

    switch (planId) {
      case 'monthly_subscription':
        return plans.pro;

      case 'monthly_subscription_aac':
        return plans.essential;

      default:
        return plans.unknown || '-';
  }
}

}
